import get from 'lodash.get';

import { CropsurePassword } from 'services/cropsurePasswords/types';
import {
    VirtualizedTableItem,
    VirtualizedTableColumns
} from 'services/virtualizedTable/types';
import { selectCropsurePasswordsArray } from 'services/cropsurePasswords/selectors';
import {
    FIELD_TYPE_STRING,
    FIELD_TYPE_PASSWORD,
    FIELD_TYPE_DATE
} from 'components/VirtualizedTable/constants';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectIsAdmin } from 'services/usersMe/selectors';
// @ts-ignore
import { selectCurrentSeasonIsComplete } from 'services/currentSeasonId/selectors';

const selectCropsurePasswordsTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths()],
    (tableColumnWidths) => {
        const result: VirtualizedTableColumns = [
            {
                label: 'RPIN',
                value: 'orchardRpin',
                width: 200,
                type: FIELD_TYPE_STRING,
                validators: 'isOrchardRpin',
                disableUpdating: true,
                fieldProps: {
                    autoComplete: 'off',
                    'data-lpignore': 'true'
                }
            },
            {
                label: 'Password',
                value: 'password',
                width: 250,
                type: FIELD_TYPE_PASSWORD,
                validators: ['isRequired', 'minLength8'],
                disableSorting: true,
                disableSearching: true,
                fieldProps: {
                    autoComplete: 'new-password',
                    'data-lpignore': 'true'
                }
            },
            {
                label: 'Last Updated',
                value: 'updatedAt',
                width: 250,
                type: FIELD_TYPE_DATE,
                dateFormat: 'MMM d yyyy h:mm aaa',
                disableSearching: true
            }
        ];

        return result.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

const selectCropsurePasswordItems = createDeepEqualSelector(
    selectCropsurePasswordsArray,
    (cropsurePasswords) =>
        cropsurePasswords.map(
            (cropsurePassword: CropsurePassword): VirtualizedTableItem => {
                return {
                    key: cropsurePassword.uuid,
                    id: cropsurePassword.id,
                    orchardRpin: cropsurePassword.orchardRpin,
                    password: cropsurePassword.password,
                    updatedAt: cropsurePassword.updatedAt
                };
            }
        )
);

const selectIsWritable = createDeepEqualSelector(
    selectIsAdmin,
    selectCurrentSeasonIsComplete,
    (isAdmin: boolean, currentSeasonIsComplete: boolean) =>
        isAdmin && !currentSeasonIsComplete
);

export {
    selectCropsurePasswordsTableColumns,
    selectCropsurePasswordItems,
    selectIsWritable
};
